(function () {
  const config = window.bundleDiscountConfig || {};
  const propertyName = 'Набір';
  const seenNames = new Set();
  const bundles = (Array.isArray(config.bundles) ? config.bundles : [config])
    .map((bundle) => {
      const bundleName = bundle && typeof bundle.bundleName === 'string' ? bundle.bundleName.trim() : '';
      return {
        bundleName,
        normalizedName: bundleName.toLowerCase(),
        requiredQuantity: Math.max(1, parseInt(bundle && bundle.requiredQuantity, 10) || 2),
      };
    })
    .filter((bundle) => {
      if (!bundle.bundleName || seenNames.has(bundle.normalizedName)) return false;
      seenNames.add(bundle.normalizedName);
      return true;
    });

  if (!bundles.length) return;

  let isProcessing = false;
  let scheduledRun = null;

  // Спільна черга з kabuki-promo.js, щоб скрипти не перезаписували промокоди один одного
  function runExclusive(task) {
    const previous = window.__cartDiscountLock || Promise.resolve();
    const next = previous.then(task, task);
    window.__cartDiscountLock = next.catch(() => {});
    return next;
  }

  function getAppliedDiscountCodes(cart) {
    return (Array.isArray(cart.discount_codes) ? cart.discount_codes : [])
      .map((item) => (typeof item === 'string' ? item : item && item.code) || '')
      .map((value) => String(value).trim())
      .filter(Boolean);
  }

  function getBundleQuantity(cart, normalizedName) {
    return cart.items.reduce((total, item) => {
      const value = item.properties && item.properties[propertyName];
      if (value && String(value).trim().toLowerCase() === normalizedName) {
        return total + item.quantity;
      }
      return total;
    }, 0);
  }

  async function fetchCart() {
    const response = await fetch(`${routes.cart_url}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Cart request failed with status ${response.status}`);
    }

    return response.json();
  }

  async function refreshMainCartFooter() {
    const footerRoot = document.getElementById('main-cart-footer');
    if (!footerRoot) return;

    const response = await fetch(`${routes.cart_url}?section_id=main-cart-footer`, {
      credentials: 'same-origin',
    });
    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const nextFooter = documentFragment.getElementById('main-cart-footer');

    if (nextFooter) {
      footerRoot.innerHTML = nextFooter.innerHTML;
      footerRoot.className = nextFooter.className;
    }
  }

  async function refreshRenderedCart() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-discount' });
    }

    await refreshMainCartFooter();
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { source: 'bundle-discount' },
    }));
  }

  function setProcessing(isActive) {
    document.querySelectorAll('cart-drawer, cart-items').forEach((element) => {
      element.classList.toggle('kabuki-promo-loading', isActive);
      element.setAttribute('aria-busy', isActive ? 'true' : 'false');
    });
  }

  async function updateCartDiscount(discountCodes) {
    setProcessing(true);

    const response = await fetch(routes.cart_update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        discount: discountCodes.join(','),
      }),
    });

    if (!response.ok) {
      throw new Error(`Discount update failed with status ${response.status}`);
    }

    await response.json();
    await refreshRenderedCart();
  }

  async function syncBundleDiscount() {
    if (isProcessing) return;
    isProcessing = true;
    const endCheckoutBusy = window.cartCheckoutBusy?.begin();

    try {
      const cart = await fetchCart();
      const appliedCodes = getAppliedDiscountCodes(cart);
      let nextCodes = appliedCodes.slice();

      bundles.forEach(({ bundleName, normalizedName, requiredQuantity }) => {
        const isEligible = getBundleQuantity(cart, normalizedName) >= requiredQuantity;
        const isApplied = nextCodes.some((code) => code.toLowerCase() === normalizedName);

        if (isEligible && !isApplied) {
          nextCodes.push(bundleName);
        } else if (!isEligible && isApplied) {
          nextCodes = nextCodes.filter((code) => code.toLowerCase() !== normalizedName);
        }
      });

      const hasChanges =
        nextCodes.length !== appliedCodes.length || nextCodes.some((code, index) => code !== appliedCodes[index]);

      if (hasChanges) {
        await updateCartDiscount(nextCodes);
      }
    } catch (error) {
      console.error('Bundle discount sync failed:', error);
    } finally {
      setProcessing(false);
      isProcessing = false;
      endCheckoutBusy?.();
    }
  }

  function scheduleSync(delay) {
    if (scheduledRun) window.clearTimeout(scheduledRun);
    scheduledRun = window.setTimeout(() => {
      scheduledRun = null;
      runExclusive(syncBundleDiscount);
    }, delay);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync(600);
  });

  document.addEventListener('cart:updated', function (event) {
    if (event.detail?.source === 'bundle-discount') return;
    scheduleSync(500);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'bundle-discount') return;
      scheduleSync(500);
    });
  }
})();
